import React, { useContext, useState } from 'react';
import InfoItems from './InfoItems/InfoItems';
import { LocalizationContext } from '../../context/localizationContext';
import caretRight from '../../assets/images/icons/caret-right.svg';
import Styles from './Info.module.scss';

const Info = () => {
  const localization = useContext(LocalizationContext);
  const { localizationState } = localization;
  const { infoDescriptions } = localizationState.localization;
  const [hideInfo, setHideInfo] = useState(false);

  return (
    <div className={Styles.infoCol}>
      <div
        className={`${Styles.infoColHeaderText} ${
          hideInfo ? Styles.rotateCaretDown : Styles.rotateCaretUp
        }`}
        onClick={() => setHideInfo(!hideInfo)}
      >
        {infoDescriptions.locatorText}
        <img src={caretRight} />
      </div>
      <div className={hideInfo ? Styles.hideInfo : ''}>
        <InfoItems localization={infoDescriptions} />
      </div>
      {!hideInfo ? (
        <div
          className={Styles.cantLocateSerial}
          dangerouslySetInnerHTML={{
            __html: infoDescriptions?.cantLocateSerial ?? '',
          }}
        />
      ) : (
        ''
      )}
    </div>
  );
};

export default Info;
